import * as React from "react";
import "./SentBackIcon.scss";

export const StatusIcon: React.SFC = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentList/StatusIcon.tsx